import { classnames } from 'Utils/classnames/classnames.utils';

const small = {
  thSeparated: 'border-b-1 border-lightGrey p-10',
  thRoom: 'p-10',
  thFlexRates: 'border-b-1 border-lightGrey p-10',
};

export const themes = {
  default: small,
  medium: small,
  large: {
    thSeparated: classnames(small.thSeparated, 'sm:p-20'),
    thRoom: classnames(small.thRoom, 'sm:p-20'),
    thFlexRates: classnames(small.thFlexRates, 'sm:p-20'),
  },
};
